import { z } from 'zod';

// Listado ligero de eventos archivados para el sitemap. La ficha de detalle
// se sirve por `/v1/event/by-slug` con fallback a la colección `archived_events`.
export const ArchivedEventListItemSchema = z.object({
  slug: z.string(),
  updatedAt: z.string().optional(),
});

export const ArchivedEventsListResponseSchema = z.object({
  items: z.array(ArchivedEventListItemSchema),
});

export type ArchivedEventListItem = z.infer<typeof ArchivedEventListItemSchema>;
export type ArchivedEventsListResponse = z.infer<
  typeof ArchivedEventsListResponseSchema
>;
